<template>
    <div class="bg_white" >
      <van-nav-bar
      title="我有疑惑"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      >
      <template #right>
          <van-icon name="chat-o" size="20"/>
      </template>
      </van-nav-bar>

      <div>
        <van-form @submit="onSubmit">
          <van-field
            v-model="param.contents"
            name="问题"
            label="问题："
            placeholder="标题"
            label-width="42px"
            :rules="[{ required: true, message: '提问问题' }]"
          />
          <van-field
            v-model="param.descp"
            label-width="42px"
            name="描述"
            label="描述："
            placeholder="问题详细描述"
            :rules="[{ required: true, message: '问题描述' }]"
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            show-word-limit
          />
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">提交</van-button>
          </div>
        </van-form>
      </div>


    </div>
</template>

<script>
import { addAsk } from '../../api/custom';
export default {
  data() {
    return {
        param:{
          contents:"",
          descp:"",
        }
    }

   },
   created(){
   
   },
   methods: {
    onSubmit(){
      addAsk(this.param).then(res=>{
        if(res.success){
          this.$dialog.alert({
                  message: "提交成功，等待讲师回复！",
                  theme: 'round-button',
                  confirmButtonText:'确定'
                })
        this.param.contents="",
        this.param.descp=""


      return false
        }
      })
    },
    onClickLeft() {
    this.$router.back()
    },
    onClickRight() {
      this.$router.push("/online")
    },
    
  }

};
</script>

<style lang="less">
.header {
  
  border-bottom: 1px solid #ccc;
  text-align: center;
  width: 100%;
  height: 300px;
  line-height: 450px;
}
.loginbox{
  box-sizing: border-box;
  padding:15px;
  text-align: center;
  
  
}
.header image {
  width: 200px;
  height: 200px;
}

.content {
   margin-left: 20px;
   margin-top: 20px;
  // margin-bottom: 90px;
  font-size: 14px;
  text-align: left;
}
.mt20{
  margin-top: 40px;
}
.content text {
  display: block;
  color: #9d9d9d;
  margin-top: 40px;
}

.bottom {
  border-radius: 80px;
  margin: 70px 50px;
  font-size: 35px;
}

</style>

